import { Card, CardContent, Grid, Typography } from "@mui/material";
import React from "react";

export interface SummaryStatItem {
  label: string;
  value: string | number;
  color?: string;
  onClick?: () => void;
  active?: boolean;
}

interface SummaryStatCardsProps {
  items: SummaryStatItem[];
  sx?: Record<string, unknown>;
  centered?: boolean;
}

const SummaryStatCards: React.FC<SummaryStatCardsProps> = ({ items, sx, centered = false }) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        mb: 2,
        ...(centered ? { justifyContent: "center" } : {}),
        ...sx,
      }}
    >
      {items.map((item) => (
        <Grid item xs={12} sm={6} md={3} key={item.label}>
          <Card
            elevation={item.active ? 4 : 2}
            onClick={item.onClick}
            sx={{
              height: "100%",
              border: item.active ? "2px solid" : "1px solid",
              borderColor: item.active ? "primary.main" : "divider",
              cursor: item.onClick ? "pointer" : "default",
              transition: "all 0.2s ease",
              "&:hover": item.onClick
                ? {
                    borderColor: "primary.main",
                    transform: "translateY(-2px)",
                  }
                : undefined,
            }}
          >
            <CardContent>
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "success.main" }}
              >
                {item.label}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "text.primary", mt: 0.5 }}
              >
                {item.value}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryStatCards;
